import { StorageScope } from "utilities/storageScope";

export const ggStorage = new StorageScope(":GoGetter");
